import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=0043b739&scoped=true"
import script from "./ItemCard.vue?vue&type=script&lang=js"
export * from "./ItemCard.vue?vue&type=script&lang=js"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=0043b739&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0043b739",
  null
  
)

export default component.exports